import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardImg, CardBody } from "reactstrap";
import smoothscroll from 'smoothscroll-polyfill';

import { getMessage } from "CONFIG/i18n";
import DeleteCanvasConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
//import ic_video_close from "ASSETS/Images/ic_cancel_start_session.svg";

import "./CanvasList.less";
import { COMPONENT_IN_FOCUS, Modules } from "UTILS/Constants";
import { CANVAS_TYPES, CANVAS_SOURCE } from "UTILS/Constants";
import { isDesktopView, isMobileView } from '@/Utils/Utility';
import { LANGUAGE } from "../../../Utils/Constants";

import ic_canvas_small from "ASSETS/Images/header_center/ic_canvas_white.svg";
export default class CanvasList extends Component {
  
  static propTypes = {
    canvases: PropTypes.object,
    changeActiveCanvas: PropTypes.func,
    deleteCanvas: PropTypes.func,
    activeCanvas: PropTypes.number,
    enableControls: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmationModal: false,
      canvasIdNumber: '',
      canvasType: '',
      slideIndex: 0,
    }
    smoothscroll.polyfill();
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    const isFocusCanvas = this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS && (this.props.screenSharingParticipantId == null || this.props.isZoomOut);
    setTimeout(() =>
      this.scrollToActiveCanvas(isFocusCanvas ? true : false)
    , 500);

    this.setCanvasListPosition();
  }

  componentWillUnmount() {
    this.scrollToActiveCanvas();
  }

  componentDidUpdate(prevProps) {
    if(this.props.activeCanvas !== prevProps.activeCanvas && this.props.isCanvasMain){
      this.scrollToActiveCanvas(true);
    }
    if (this.props.activeCanvas !== prevProps.activeCanvas && this.props.enableControls) {
      if(Object.keys(this.props.canvases).length < Object.keys(prevProps.canvases).length || Object.keys(this.props.canvases).length === Object.keys(prevProps.canvases).length){
        this.changeActiveCanvasForCanvasDisabled();
      }
    }
    if(_.size(this.props.canvases) < _.size(prevProps.canvases && this.props.isCanvasMain)
    //&& !this.props.canvases[this.props.activeCanvas].thumbnailUrl
    ) {
      console.log("hidding canvasList spinner after removing deleted canvas");
      this.props.hideCanvasListSpinner();
    }
    if(isMobileView(this.props.orientation)){
      if(prevProps.isZoomOut && !this.props.isZoomOut && this.props.screenSharingParticipantId !== null){
        this.scrollToActiveCanvas(this.props.isCanvasMain ? true : false)
      }
    }
  }

  changeActiveCanvasForCanvasDisabled = () => {
    if (this.props.activeCanvas == "1" && this.props.modules.indexOf(Modules.CANVAS) == -1) {
      const firstCanvasData = Object.values(this.props.canvases).find(_, index => {
        return index === 0;
      });
      const firstCanvasId = Object.keys(this.props.canvases).find(_, index => {
        return index === 0;
      });

      if (this.props.activeCanvas !== firstCanvasId) {
        this.props.onCanvasSwitched(firstCanvasData.canvasType);

        if (firstCanvasData.canvasType !== CANVAS_TYPES.PDF) {
          console.log("Showing spinner in canvaslist on clicking canvas");
          this.props.showCanvasListSpinner();
        } else {
          this.props.showSpinner();
        }

        this.props.changeActiveCanvas(
          Number(firstCanvasId),
          firstCanvasData.canvasType,
          true,
          () => {
            console.log("[in changeActiveCanvas callback] this.props.activeCanvasFileUrl: ", firstCanvasData.filleUrl);
            if (!firstCanvasData.filleUrl) {
              console.log("hidding canvasList spinner in changeActiveCanvas callback ");
              this.props.hideCanvasListSpinner();
            } else {
              this.props.hideCanvasListSpinner();
            }
          }
        );
      }
    }
  }

  setCanvasListPosition = () => {
    const canvasListContainer = document.getElementsByClassName("canvasListContainer");
    const dashboardSide = document.getElementsByClassName("dashboardSide");
    const zoomButtons = document.getElementsByClassName("canvasZoomButtons");
    const scrollY = document.getElementById("scrollY");
    const header = document.getElementById("commonHeader");
    const padding = 8;

    if (isMobileView(this.props.orientation)) {
      if (canvasListContainer[0] && dashboardSide[0] && zoomButtons[0]) {
        canvasListContainer[0].style.position = "fixed";
        canvasListContainer[0].style.bottom = dashboardSide[0].getBoundingClientRect().height + "px";
        zoomButtons[0].style.bottom = canvasListContainer[0].clientHeight + padding + "px";
      }
    } else {
      if (scrollY && header) {
        scrollY.style.maxHeight = window.innerHeight - header.clientHeight - padding + "px";
      }
    }
  }

  scrollToActiveCanvas = (isFocusCanvas) => {
    if (isMobileView(this.props.orientation)){
      if(this.canvasRef.current){
        const moveToWidth = this.canvasRef.current.offsetWidth / 2;
        const itemLength = this.props.getValidActiveCanvasId() === 1 ? 2 : this.props.getValidActiveCanvasId();
        const afterScrollLeft = isFocusCanvas ? moveToWidth * (itemLength - 2) : 0;
        const newIndex = isFocusCanvas ? afterScrollLeft / moveToWidth : 0;
        
        this.canvasRef.current.style.transition = "transform .3s ease-out";
        this.canvasRef.current.style.transform = `translate(-${afterScrollLeft}px, 0)`; 
        this.setState({ slideIndex: newIndex });
      }
    } else if (isDesktopView(this.props.orientation)) {
      const canvasListScrollX = document.getElementsByClassName("canvasListScrollX")
      if (canvasListScrollX[0]) {
        canvasListScrollX[0].scrollIntoView(false);
      }
    }
  }

  handleNoClick = () => {
    this.props.setValue("showDeleteConfirmationModal", false);
  }
  
  slideMovePrev = (e, canvases) => {
    e.stopPropagation()
    let prevSlideNum = this.state.slideIndex >= 1 ? this.state.slideIndex - 1 : canvases.length - 2;
    this.slideMove(-1, prevSlideNum, canvases.length - 1)
    this.setState({slideIndex: prevSlideNum});
  }

  slideMoveNext = (e, canvases) => {
    e.stopPropagation()
    let nextSlideNum = this.state.slideIndex < canvases.length - 2 ? this.state.slideIndex + 1 : 0;
    this.slideMove(1, nextSlideNum, canvases.length - 1)
    this.setState({slideIndex: nextSlideNum});
  }
  
  slideMove = (step, afterNum, max) => {
    const moveToWidth = this.canvasRef.current.offsetWidth / 2;
    let afterScrollLeft = moveToWidth * afterNum;
    this.canvasRef.current.style.transition = "transform .3s ease-out";
    if(afterNum >= max && step > 0) {
      this.canvasRef.current.style.transform = `translate(0, 0)`;
    } else if(afterNum >= max && step < 0) {
      this.canvasRef.current.style.transform = `translate(-${moveToWidth * (max - 1)}px, 0)`;
    }
    else {
      this.canvasRef.current.style.transform = `translate(-${afterScrollLeft}px, 0)`;
    }
  }

  renderNavigator = (prevFunc, nextFunc) => {
    return(
      <div className="slider-navigator">
        <svg
          onClick={prevFunc}
          className="arrow arrow--left"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
        <svg
          onClick={nextFunc}
          className="arrow arrow--right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
      </div>
    )
  }

  renderCanvasItem = (canvas, canvasId, canvasIdNumber) => {
    return (
      <div
        key={canvas.canvasType + canvasId}
        id={canvasIdNumber}
        className={
          this.props.enableControls
            ? "canvasList cursorPointer"
            : "canvasList"
        }>
        <Card
          onClick={() => {
            // Execute following code if the card is enabled
            if (this.props.enableControls) {
              if (this.props.activeCanvas != canvasIdNumber) {
                this.props.onCanvasSwitched(canvas.canvasType);
                //this.props.closePopover();

                if (canvas.canvasType !== CANVAS_TYPES.PDF) {
                  console.log("Showing spinner in canvaslist on clicking canvas");
                  this.props.showCanvasListSpinner();
                } else {
                  this.props.showSpinner();
                }

                this.props.changeActiveCanvas(
                  canvasIdNumber,
                  canvas.canvasType,
                  true,
                  () => {
                    console.log("[in changeActiveCanvas callback] this.props.activeCanvasFileUrl: ", this.props.activeCanvasFileUrl);
                    if (!this.props.activeCanvasFileUrl) {
                      console.log("hidding canvasList spinner in changeActiveCanvas callback ");
                      this.props.hideCanvasListSpinner();
                    } else {
                      this.props.hideCanvasListSpinner();
                    }
                  }
                );
              }
            }
            if(isMobileView(this.props.orientation)){
              this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);

              if(this.props.screenSharingParticipantId !== null){
                this.props.setValue("isZoomOut", true);
              }         
            }
          }}
          className={
            "card buttonCard " +
            (this.props.activeCanvas === canvasIdNumber
              ? " activeCanvas"
              : "") +
            (!this.props.enableControls ? " cursorDefault" : " cursorPointer")
          }
          id={(this.props.activeCanvas === canvasIdNumber
            ? "activeCanvas"
            : "")}
        >
          <CardBody className={canvas.thumbnailUrl ? "" : "bodyHeight"}>
            {/*this.props.enableCloseIcon &&
            _.size(this.props.canvases) > 1 &&
            (
              <CardImg
                src={ic_video_close}
                className={"closeIcon " + (this.props.enableControls ? "cursorPointer" : "disable")}
                onClick={event => {
                  if (!navigator.onLine) {
                    toastr.error(getMessage("NETWORK_ERROR"));
                    return;
                  }
                  event.stopPropagation();
                  this.props.setValue("canvasIdNumber", canvasIdNumber);
                  this.props.setValue("canvasType", canvas.canvasType);
                  this.props.setValue("showDeleteConfirmationModal", true);
                }}
              />
              )*/}
            {isMobileView(this.props.orientation) && !this.props.isCanvasMain &&
            <div className="canvasHeading">
              <img src={ic_canvas_small} className="toggleIconCanvas" />
              <label className="title">{getMessage("CANVAS")}
              </label>
            </div>
            } 
            {canvas.thumbnailUrl && canvas.canvasType !== CANVAS_TYPES.PDF ? (
              <CardImg
                src={canvas.thumbnailUrl}
                className="imageWidth"
                id={canvasIdNumber}
                onLoad={() => {
                  if (this.props.activeCanvas == canvasIdNumber) {
                    console.log("hidding canvasList spinner in image onload: ", canvasIdNumber);
                    this.props.hideCanvasListSpinner();
                  }
                }}
              />
            ) : <div title={canvas.originalFileName} className="file-name">
              <span className="file-name-ellipsis">{canvas.originalFileName}</span>
            </div>}
          </CardBody>
        </Card>
      </div>
    );
  }

  renderCanvasList = () => {
    let newCanvases = this.props.canvases;
    if (!this.props.isCanvasMain) {
      newCanvases = Object.values(this.props.canvases).filter((item) => {
        return item.canvasId === this.props.activeCanvas;
      });
    }

    return (
      <div className="canvasListScrollX" ref={this.canvasRef}>
        {_.map(newCanvases, (canvas, canvasId) => {
          const canvasIdNumber = parseInt(canvasId, 10);       
          if (canvas.canvasType == CANVAS_TYPES.REGULAR && canvas.canvasSource == CANVAS_SOURCE.SNAPSHOT)
            return null;
          return this.renderCanvasItem(canvas, canvasId, canvasIdNumber);
        })}
      </div>
    );
  }

  render() {
    const slideItems = Object.keys(this.props.canvases);

    if (slideItems.length >= 1) {
      if (this.state.slideIndex >= slideItems.length) {
        this.setState({
          slideIndex: slideItems.length - 1
        });
      }
    }
    return (
      this.props.isCanvasMain ?
        <>
          <div
            className="scrollY addCanvasDiv"
            id="scrollY"
          >
            {this.renderCanvasList()}
            {
              this.props.showDeleteConfirmationModal &&
              <DeleteCanvasConfirmationModal
                show={true}
                isDoubleButton={true}
                handleNoClick={this.handleNoClick}
                handleYesClick={() => {
                  this.handleNoClick();
                  console.log("showing canvasList spinner in delete canvas");
                  this.props.showCanvasListSpinner();
                  this.props.deleteCanvas(
                    this.props.canvasIdNumber,
                    this.props.canvasType
                  );
                }}
                message={getMessage("DELETE_CANVAS_CONFIRMATION_TEXT")}
              />
            }
          </div>
          {isMobileView(this.props.orientation) && slideItems.length > 2 && this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS &&
            this.renderNavigator(
              (e) => this.slideMovePrev(e, slideItems),
              (e) => this.slideMoveNext(e, slideItems)
            )
          }
        </>
        : this.renderCanvasList()
    );
  }
}
